import $ from "jquery";
import App from "../src/App";
import "../components/MarqueeSection";
import { Swiper } from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "swiper/scss/effect-fade";

$(".js-gallery").each(function () {
  const $gallery = $(this);
  const $swiperEl = $gallery.find(".swiper");
  const $currentEl = $gallery.find(".gallery-counter span:first-child");
  const $totalEl = $gallery.find(".gallery-counter span:last-child");

  // Initialize Swiper
  const swiper = new Swiper($swiperEl[0], {
    modules: [Navigation],
    slidesPerView: 1,
    autoplay: false,
    loop: false,
    speed: 2000,
    navigation: {
      prevEl: $gallery.find(".gallery__button--prev")[0],
      nextEl: $gallery.find(".gallery__button--next")[0],
    },
  });

  // Define counter function
  const updateCounter = () => {
    const realIndex = swiper.activeIndex;
    $currentEl.text(String(realIndex + 1).padStart(2, "0"));
    $totalEl.text(String(swiper.slides.length).padStart(2, "0"));
  };

  // Set up event listeners after initialization
  swiper.on("init", updateCounter);
  swiper.on("slideChange", updateCounter);

  // Manually trigger initialization
  swiper.emit("init");
});

$(".js-banners").each(function () {
  const $banners = $(this);
  const $swiperEl = $banners.find(".swiper");
  const paginationEl = $banners.find(".swiper-pagination")[0];

  // Initialize Swiper
  const swiper = new Swiper($swiperEl[0], {
    modules: [Navigation, Pagination],
    slidesPerView: "auto",
    autoplay: false,
    autoHeight: true,
    loop: false,
    pagination: {
      el: paginationEl,
      clickable: true,
    },
  });

  // Manually trigger initialization
  swiper.emit("init");
});

$(".js-testimonials").each(function () {
  const $testimonials = $(this);
  const $swiperEl = $testimonials.find(".swiper");
  const paginationEl = $testimonials.find(".swiper-pagination")[0];

  // Initialize Swiper
  const swiper = new Swiper($swiperEl[0], {
    modules: [Navigation, Pagination, EffectFade],
    effect: "fade",
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay: false,
    speed: 600,
    loop: false,
    pagination: {
      el: paginationEl,
      clickable: true,
    },
    navigation: {
      prevEl: $testimonials.find(".testimonials__button--prev")[0],
      nextEl: $testimonials.find(".testimonials__button--next")[0],
    },
  });

  // Manually trigger initialization
  swiper.emit("init");
});
